const firebaseConfig = {
  apiKey: "AIzaSyCX1A8WlLx_C9wjAXJQdRIC46w9BWPfEo0",
  authDomain: "ema-john-normal.firebaseapp.com",
  databaseURL: "https://ema-john-normal.firebaseio.com",
  projectId: "ema-john-normal",
  storageBucket: "ema-john-normal.appspot.com",
  messagingSenderId: "696102263628",
  appId: "1:696102263628:web:bd54d620ec4089fad14de9"
};
export default firebaseConfig;